import React, { Fragment, useState, useEffect } from 'react';
import Loader from "../layout/loader";
import Header from '../layout/header'
import Sidebar from '../layout/sidebar'
import Footer from '../layout/footer'
import ThemeCustomize from "../layout/theme-customizer";
import { ToastContainer } from 'react-toastify'






const App = ({ children }) => {
  console.warn = () => { }
  const [activetab, setActivetab] = useState(window.localStorage.getItem('activetab'))
  useEffect(() => {
    setActivetab(window.localStorage.getItem('activetab'))
  }, [window.localStorage.getItem('activetab')]);
  
 
  return (
    <Fragment>
      <Loader />
     
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <Header activetab={activetab} setActivetab={setActivetab} />
        <div className="page-body-wrapper sidebar-icon">
          <Sidebar activetab={activetab} setActivetab={setActivetab} />
          <div className="page-body" >

            {children}

          </div>
          <Footer activetab={activetab} setActivetab={setActivetab} />
          <ThemeCustomize />
        </div>
      </div>

      <ToastContainer />
    </Fragment>
  );
}

export default App;